import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import Theme from '../../components/Button';
// mock
import CadVendaForms from '../FormsTemplates/Venda/CadastroVendaForms';
import CadVendaAgenciaViagemForms from '../FormsTemplates/Venda/CadVendaAgenciaViagemForms';



export default function CadVenda() {

  const validaTipoComercio = localStorage.getItem(['tipo_comercio']);
  const tipoComercio = parseInt(validaTipoComercio, 10);
  let CadastroVenda = CadVendaForms;
  
  if (tipoComercio === 5) {
    CadastroVenda = CadVendaAgenciaViagemForms;
  }else {
    CadastroVenda = CadVendaForms;
  }

  return (
    <Page title="Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Venda
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <CadastroVenda/>    
      </Container>
    </Page>
  );
}
